var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.downloadFile}},[_c('img',{attrs:{"src":require("@/assets/icons/download.svg")}}),_c('div',[_vm._v("\n        "+_vm._s(_vm.$t('download'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }